import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { MessageResourceTagIcon } from 'components/MessageResourceTag/MessageResourceTagIcon'
import { AttachmentWithUploadStatus } from 'types/AttachmentWithUploadStatus'
import { cn } from 'utils/cn'

import { getFileIcon } from 'utils/getFileIcon'

import { AttachmentStatus } from './AttachmentStatus'

import type { FC } from 'react'

type Props = {
  attachmentStatus: AttachmentWithUploadStatus['status']
  contentType: AttachmentWithUploadStatus['contentType']
  isDetailedView?: boolean
  isPending?: boolean
}

export const AttachmentIconAndStatus: FC<Props> = ({ attachmentStatus, contentType, isDetailedView, isPending }) => {
  const { color, icon } = getFileIcon({ attachmentStatus, contentType })

  return (
    <div className={cn('flex items-center', { 'text-danger': attachmentStatus === 'error' })}>
      <MessageResourceTagIcon
        icon={(
          <FontAwesomeIcon
            className={cn({ 'animate-spin': attachmentStatus === 'uploading' || attachmentStatus === 'deleting' })}
            icon={icon}
            style={color ? { color } : undefined}
          />
        )}
        isDetailedView={isDetailedView}
        resourceType="attachment"
        status={attachmentStatus}
      />
      {isDetailedView && isPending && (
        <div className="ml-3 text-sm font-medium">
          <AttachmentStatus attachmentStatus={attachmentStatus} />
        </div>
      )}
    </div>
  )
}
